import { schoolConstants } from "./constants";

const INITIAL_STATE = {
  previousCalendarID: "20250000-5026-4B33-9EAA-000000002025", //
  currentCalendarID: "20260000-5026-4B33-9EAA-000000002026", //
  nextCalendarID: "20270000-5026-4B33-9EAA-000000002027", //
  calendarLevels: [],
  cyclesLevels: [],
  gradesLevels: [],
  level: {},
  grades: [],
  enrollFile: [],
};

export function school(state = INITIAL_STATE, action) {
  switch (action.type) {
    //

    case schoolConstants.ENROLL_STUDENT_COURSE:
      return {
        ...state,
        enrollFile: {
          ...state.enrollFile,
          currentCourse: action.currentCourse,
        },
      };

    //

    case schoolConstants.DELETE_ENROLL_FILE:
      return {
        ...state,
        enrollFile: state.enrollFile.filter(
          (file) =>
            file.enroll_persona_id !== action.deletedFile.enroll_persona_id,
        ),
      };

    case schoolConstants.LOAD_ENROLL_FILE:
      return {
        ...state,
        enrollFile: action.enrollFile,
      };

    case schoolConstants.SET_CURRENT_CALENDAR:
      return {
        ...state,
        currentCalendarID: action.currentCalendarID,
      };

    case schoolConstants.CLEAN_LEVELS:
      return {
        ...state,
        gradesLevels: [],
        cyclesLevels: [],
        levelCourses: [],
      };

    case schoolConstants.SHOW_LEVEL_3:
      return {
        ...state,
        gradesLevels: action.levelChilds,
        level: action.level,
        levelCourses: [],
      };

    case schoolConstants.SHOW_LEVEL_COURSES:
      return {
        ...state,
        levelCourses: action.levelCourses,
      };

    case schoolConstants.SHOW_LEVEL_2:
      return {
        ...state,
        cyclesLevels: action.levelChilds,
        level: action.level,
        levelCourses: [],
      };

    case schoolConstants.SHOW_CALENDAR_LEVELS:
      return {
        ...state,
        calendarLevels: action.calendarLevels,
      };

    default:
      return state;
  }
}
